import { useCallback, useState } from 'react';

/**
 * Confirmation for destructive media actions.
 *
 * WHY MEDIA GETS A CONFIRM WHEN A CHECKLIST ITEM DOES NOT: a photo, a video or
 * a voice note taken at a booth is the one thing in this app that cannot be
 * recreated. Once the buyer has left Guangzhou, a mis-tapped delete is gone —
 * the Blob is removed from IndexedDB and the file from the server. A checklist
 * line or a follow-up can simply be typed again.
 *
 * The delete control on a media thumbnail is also a 22px target sitting on top
 * of the thumbnail itself, so a mis-tap while scrolling a grid is likely, not
 * theoretical.
 *
 * Usage:
 *   const confirm = useConfirmRemove();
 *   <button onClick={() => confirm.ask(item, () => doRemove(item))} />
 *   {confirm.node}
 */
export default function useConfirmRemove() {
  const [pending, setPending] = useState(null);

  const ask = useCallback((item, onYes, label) => {
    setPending({ item, onYes, label });
  }, []);

  const cancel = useCallback(() => setPending(null), []);

  const accept = useCallback(() => {
    if (pending && pending.onYes) pending.onYes();
    setPending(null);
  }, [pending]);

  return { pending, ask, cancel, accept };
}
